/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as DesignRouteImport } from './routes/design'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppOrgRouteImport } from './routes/_app/$org'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as ConnectCallbackRouteImport } from './routes/connect.callback'
import { Route as InviteInvitationIdRouteImport } from './routes/invite.$invitationId'
import { Route as AppOrgIndexRouteImport } from './routes/_app/$org/index'
import { Route as AppOrgHostRouteImport } from './routes/_app/$org/$host'
import { Route as AppOrgSettingsRouteImport } from './routes/_app/$org/settings'
import { Route as AppOrgSitesRouteImport } from './routes/_app/$org/sites'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminFeedsRouteImport } from './routes/_app/admin/feeds'
import { Route as AppAdminQueuesRouteImport } from './routes/_app/admin/queues'
import { Route as AppSettingsAccountRouteImport } from './routes/_app/settings.account'
import { Route as AppSettingsWorkspaceRouteImport } from './routes/_app/settings.workspace'
import { Route as AppSitesSiteIdRouteImport } from './routes/_app/sites.$siteId'
import { Route as AppOrgHostIndexRouteImport } from './routes/_app/$org/$host/index'
import { Route as AppOrgHostQueriesRouteImport } from './routes/_app/$org/$host/queries'
import { Route as AppOrgHostSettingsRouteImport } from './routes/_app/$org/$host/settings'
import { Route as AppOrgSettingsIndexRouteImport } from './routes/_app/$org/settings/index'
import { Route as AppOrgSettingsAccountRouteImport } from './routes/_app/$org/settings/account'
import { Route as AppOrgSettingsConnectionsRouteImport } from './routes/_app/$org/settings/connections'
import { Route as AppOrgSettingsWorkspaceRouteImport } from './routes/_app/$org/settings/workspace'
import { Route as AppAdminActionsActionIdRouteImport } from './routes/_app/admin/actions/$actionId'
import { Route as AppAdminActionsListRouteImport } from './routes/_app/admin/actions/_list'
import { Route as AppAdminAiListRouteImport } from './routes/_app/admin/ai/_list'
import { Route as AppOrgHostBacklinksDomainIdRouteImport } from './routes/_app/$org/$host/backlinks/$domainId'
import { Route as AppOrgHostBacklinksListRouteImport } from './routes/_app/$org/$host/backlinks/_list'
import { Route as AppOrgHostCompetitorsListRouteImport } from './routes/_app/$org/$host/competitors/_list'
import { Route as AppOrgHostKeywordsQueryIdRouteImport } from './routes/_app/$org/$host/keywords/$queryId'
import { Route as AppOrgHostKeywordsListRouteImport } from './routes/_app/$org/$host/keywords/_list'
import { Route as AppOrgHostOutreachProspectIdRouteImport } from './routes/_app/$org/$host/outreach/$prospectId'
import { Route as AppOrgHostOutreachListRouteImport } from './routes/_app/$org/$host/outreach/_list'
import { Route as AppOrgHostPagesIndexRouteImport } from './routes/_app/$org/$host/pages/index'
import { Route as AppOrgHostPagesPageIdRouteImport } from './routes/_app/$org/$host/pages/$pageId'
import { Route as AppOrgHostSearchListRouteImport } from './routes/_app/$org/$host/search/_list'
import { Route as AppAdminActionsListIndexRouteImport } from './routes/_app/admin/actions/_list/index'
import { Route as AppAdminActionsListDetectorsRouteImport } from './routes/_app/admin/actions/_list/detectors'
import { Route as AppAdminActionsListEfficacyRouteImport } from './routes/_app/admin/actions/_list/efficacy'
import { Route as AppAdminAiListIndexRouteImport } from './routes/_app/admin/ai/_list/index'
import { Route as AppAdminAiListModelsRouteImport } from './routes/_app/admin/ai/_list/models'
import { Route as AppAdminAiListPromptsRouteImport } from './routes/_app/admin/ai/_list/prompts'
import { Route as AppAdminAiPromptsPromptIdRouteImport } from './routes/_app/admin/ai/prompts.$promptId'
import { Route as AppAdminAiRunsRunIdRouteImport } from './routes/_app/admin/ai/runs.$runId'
import { Route as AppOrgHostBacklinksListIndexRouteImport } from './routes/_app/$org/$host/backlinks/_list/index'
import { Route as AppOrgHostBacklinksListDeadRouteImport } from './routes/_app/$org/$host/backlinks/_list/dead'
import { Route as AppOrgHostBacklinksListGainedRouteImport } from './routes/_app/$org/$host/backlinks/_list/gained'
import { Route as AppOrgHostBacklinksListLostRouteImport } from './routes/_app/$org/$host/backlinks/_list/lost'
import { Route as AppOrgHostCompetitorsListIndexRouteImport } from './routes/_app/$org/$host/competitors/_list/index'
import { Route as AppOrgHostCompetitorsListCompetitorIdRouteImport } from './routes/_app/$org/$host/competitors/_list/$competitorId'
import { Route as AppOrgHostCompetitorsListManageRouteImport } from './routes/_app/$org/$host/competitors/_list/manage'
import { Route as AppOrgHostKeywordsListIndexRouteImport } from './routes/_app/$org/$host/keywords/_list/index'
import { Route as AppOrgHostKeywordsListLowHangingRouteImport } from './routes/_app/$org/$host/keywords/_list/low-hanging'
import { Route as AppOrgHostOutreachListIndexRouteImport } from './routes/_app/$org/$host/outreach/_list/index'
import { Route as AppOrgHostOutreachListAcceptedRouteImport } from './routes/_app/$org/$host/outreach/_list/accepted'
import { Route as AppOrgHostOutreachListActiveRouteImport } from './routes/_app/$org/$host/outreach/_list/active'
import { Route as AppOrgHostOutreachListApprovedRouteImport } from './routes/_app/$org/$host/outreach/_list/approved'
import { Route as AppOrgHostOutreachListDismissedRouteImport } from './routes/_app/$org/$host/outreach/_list/dismissed'
import { Route as AppOrgHostOutreachListNoReplyRouteImport } from './routes/_app/$org/$host/outreach/_list/no-reply'
import { Route as AppOrgHostOutreachListPipelineRouteImport } from './routes/_app/$org/$host/outreach/_list/pipeline'
import { Route as AppOrgHostOutreachListRejectedRouteImport } from './routes/_app/$org/$host/outreach/_list/rejected'
import { Route as AppOrgHostOutreachListSentRouteImport } from './routes/_app/$org/$host/outreach/_list/sent'
import { Route as AppOrgHostOutreachListSettingsRouteImport } from './routes/_app/$org/$host/outreach/_list/settings'
import { Route as AppOrgHostSearchListIndexRouteImport } from './routes/_app/$org/$host/search/_list/index'
import { Route as AppOrgHostSearchListSerpRouteImport } from './routes/_app/$org/$host/search/_list/serp'
import { Route as AppOrgHostSearchSerpQueryIdRouteImport } from './routes/_app/$org/$host/search/serp.$queryId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignRoute = DesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgRoute = AppOrgRouteImport.update({
  id: '/$org',
  path: '/$org',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const ConnectCallbackRoute = ConnectCallbackRouteImport.update({
  id: '/connect/callback',
  path: '/connect/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteInvitationIdRoute = InviteInvitationIdRouteImport.update({
  id: '/invite/$invitationId',
  path: '/invite/$invitationId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppOrgIndexRoute = AppOrgIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrgRoute,
} as any)
const AppOrgHostRoute = AppOrgHostRouteImport.update({
  id: '/$host',
  path: '/$host',
  getParentRoute: () => AppOrgRoute,
} as any)
const AppOrgSettingsRoute = AppOrgSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppOrgRoute,
} as any)
const AppOrgSitesRoute = AppOrgSitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => AppOrgRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFeedsRoute = AppAdminFeedsRouteImport.update({
  id: '/feeds',
  path: '/feeds',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminQueuesRoute = AppAdminQueuesRouteImport.update({
  id: '/queues',
  path: '/queues',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppSettingsAccountRoute = AppSettingsAccountRouteImport.update({
  id: '/settings/account',
  path: '/settings/account',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsWorkspaceRoute = AppSettingsWorkspaceRouteImport.update({
  id: '/settings/workspace',
  path: '/settings/workspace',
  getParentRoute: () => AppRoute,
} as any)
const AppSitesSiteIdRoute = AppSitesSiteIdRouteImport.update({
  id: '/sites/$siteId',
  path: '/sites/$siteId',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgHostIndexRoute = AppOrgHostIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrgHostRoute,
} as any)
const AppOrgHostQueriesRoute = AppOrgHostQueriesRouteImport.update({
  id: '/queries',
  path: '/queries',
  getParentRoute: () => AppOrgHostRoute,
} as any)
const AppOrgHostSettingsRoute = AppOrgHostSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppOrgHostRoute,
} as any)
const AppOrgSettingsIndexRoute = AppOrgSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrgSettingsRoute,
} as any)
const AppOrgSettingsAccountRoute = AppOrgSettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppOrgSettingsRoute,
} as any)
const AppOrgSettingsConnectionsRoute =
  AppOrgSettingsConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => AppOrgSettingsRoute,
  } as any)
const AppOrgSettingsWorkspaceRoute = AppOrgSettingsWorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => AppOrgSettingsRoute,
} as any)
const AppAdminActionsActionIdRoute = AppAdminActionsActionIdRouteImport.update({
  id: '/actions/$actionId',
  path: '/actions/$actionId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminActionsListRoute = AppAdminActionsListRouteImport.update({
  id: '/actions/_list',
  path: '/actions',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAiListRoute = AppAdminAiListRouteImport.update({
  id: '/ai/_list',
  path: '/ai',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppOrgHostBacklinksDomainIdRoute =
  AppOrgHostBacklinksDomainIdRouteImport.update({
    id: '/backlinks/$domainId',
    path: '/backlinks/$domainId',
    getParentRoute: () => AppOrgHostRoute,
  } as any)
const AppOrgHostBacklinksListRoute = AppOrgHostBacklinksListRouteImport.update({
  id: '/backlinks/_list',
  path: '/backlinks',
  getParentRoute: () => AppOrgHostRoute,
} as any)
const AppOrgHostCompetitorsListRoute =
  AppOrgHostCompetitorsListRouteImport.update({
    id: '/competitors/_list',
    path: '/competitors',
    getParentRoute: () => AppOrgHostRoute,
  } as any)
const AppOrgHostKeywordsQueryIdRoute =
  AppOrgHostKeywordsQueryIdRouteImport.update({
    id: '/keywords/$queryId',
    path: '/keywords/$queryId',
    getParentRoute: () => AppOrgHostRoute,
  } as any)
const AppOrgHostKeywordsListRoute = AppOrgHostKeywordsListRouteImport.update({
  id: '/keywords/_list',
  path: '/keywords',
  getParentRoute: () => AppOrgHostRoute,
} as any)
const AppOrgHostOutreachProspectIdRoute =
  AppOrgHostOutreachProspectIdRouteImport.update({
    id: '/outreach/$prospectId',
    path: '/outreach/$prospectId',
    getParentRoute: () => AppOrgHostRoute,
  } as any)
const AppOrgHostOutreachListRoute = AppOrgHostOutreachListRouteImport.update({
  id: '/outreach/_list',
  path: '/outreach',
  getParentRoute: () => AppOrgHostRoute,
} as any)
const AppOrgHostPagesIndexRoute = AppOrgHostPagesIndexRouteImport.update({
  id: '/pages/',
  path: '/pages/',
  getParentRoute: () => AppOrgHostRoute,
} as any)
const AppOrgHostPagesPageIdRoute = AppOrgHostPagesPageIdRouteImport.update({
  id: '/pages/$pageId',
  path: '/pages/$pageId',
  getParentRoute: () => AppOrgHostRoute,
} as any)
const AppOrgHostSearchListRoute = AppOrgHostSearchListRouteImport.update({
  id: '/search/_list',
  path: '/search',
  getParentRoute: () => AppOrgHostRoute,
} as any)
const AppAdminActionsListIndexRoute =
  AppAdminActionsListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminActionsListRoute,
  } as any)
const AppAdminActionsListDetectorsRoute =
  AppAdminActionsListDetectorsRouteImport.update({
    id: '/detectors',
    path: '/detectors',
    getParentRoute: () => AppAdminActionsListRoute,
  } as any)
const AppAdminActionsListEfficacyRoute =
  AppAdminActionsListEfficacyRouteImport.update({
    id: '/efficacy',
    path: '/efficacy',
    getParentRoute: () => AppAdminActionsListRoute,
  } as any)
const AppAdminAiListIndexRoute = AppAdminAiListIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminAiListRoute,
} as any)
const AppAdminAiListModelsRoute = AppAdminAiListModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => AppAdminAiListRoute,
} as any)
const AppAdminAiListPromptsRoute = AppAdminAiListPromptsRouteImport.update({
  id: '/prompts',
  path: '/prompts',
  getParentRoute: () => AppAdminAiListRoute,
} as any)
const AppAdminAiPromptsPromptIdRoute =
  AppAdminAiPromptsPromptIdRouteImport.update({
    id: '/ai/prompts/$promptId',
    path: '/ai/prompts/$promptId',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminAiRunsRunIdRoute = AppAdminAiRunsRunIdRouteImport.update({
  id: '/ai/runs/$runId',
  path: '/ai/runs/$runId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppOrgHostBacklinksListIndexRoute =
  AppOrgHostBacklinksListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrgHostBacklinksListRoute,
  } as any)
const AppOrgHostBacklinksListDeadRoute =
  AppOrgHostBacklinksListDeadRouteImport.update({
    id: '/dead',
    path: '/dead',
    getParentRoute: () => AppOrgHostBacklinksListRoute,
  } as any)
const AppOrgHostBacklinksListGainedRoute =
  AppOrgHostBacklinksListGainedRouteImport.update({
    id: '/gained',
    path: '/gained',
    getParentRoute: () => AppOrgHostBacklinksListRoute,
  } as any)
const AppOrgHostBacklinksListLostRoute =
  AppOrgHostBacklinksListLostRouteImport.update({
    id: '/lost',
    path: '/lost',
    getParentRoute: () => AppOrgHostBacklinksListRoute,
  } as any)
const AppOrgHostCompetitorsListIndexRoute =
  AppOrgHostCompetitorsListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrgHostCompetitorsListRoute,
  } as any)
const AppOrgHostCompetitorsListCompetitorIdRoute =
  AppOrgHostCompetitorsListCompetitorIdRouteImport.update({
    id: '/$competitorId',
    path: '/$competitorId',
    getParentRoute: () => AppOrgHostCompetitorsListRoute,
  } as any)
const AppOrgHostCompetitorsListManageRoute =
  AppOrgHostCompetitorsListManageRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => AppOrgHostCompetitorsListRoute,
  } as any)
const AppOrgHostKeywordsListIndexRoute =
  AppOrgHostKeywordsListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrgHostKeywordsListRoute,
  } as any)
const AppOrgHostKeywordsListLowHangingRoute =
  AppOrgHostKeywordsListLowHangingRouteImport.update({
    id: '/low-hanging',
    path: '/low-hanging',
    getParentRoute: () => AppOrgHostKeywordsListRoute,
  } as any)
const AppOrgHostOutreachListIndexRoute =
  AppOrgHostOutreachListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrgHostOutreachListRoute,
  } as any)
const AppOrgHostOutreachListAcceptedRoute =
  AppOrgHostOutreachListAcceptedRouteImport.update({
    id: '/accepted',
    path: '/accepted',
    getParentRoute: () => AppOrgHostOutreachListRoute,
  } as any)
const AppOrgHostOutreachListActiveRoute =
  AppOrgHostOutreachListActiveRouteImport.update({
    id: '/active',
    path: '/active',
    getParentRoute: () => AppOrgHostOutreachListRoute,
  } as any)
const AppOrgHostOutreachListApprovedRoute =
  AppOrgHostOutreachListApprovedRouteImport.update({
    id: '/approved',
    path: '/approved',
    getParentRoute: () => AppOrgHostOutreachListRoute,
  } as any)
const AppOrgHostOutreachListDismissedRoute =
  AppOrgHostOutreachListDismissedRouteImport.update({
    id: '/dismissed',
    path: '/dismissed',
    getParentRoute: () => AppOrgHostOutreachListRoute,
  } as any)
const AppOrgHostOutreachListNoReplyRoute =
  AppOrgHostOutreachListNoReplyRouteImport.update({
    id: '/no-reply',
    path: '/no-reply',
    getParentRoute: () => AppOrgHostOutreachListRoute,
  } as any)
const AppOrgHostOutreachListPipelineRoute =
  AppOrgHostOutreachListPipelineRouteImport.update({
    id: '/pipeline',
    path: '/pipeline',
    getParentRoute: () => AppOrgHostOutreachListRoute,
  } as any)
const AppOrgHostOutreachListRejectedRoute =
  AppOrgHostOutreachListRejectedRouteImport.update({
    id: '/rejected',
    path: '/rejected',
    getParentRoute: () => AppOrgHostOutreachListRoute,
  } as any)
const AppOrgHostOutreachListSentRoute =
  AppOrgHostOutreachListSentRouteImport.update({
    id: '/sent',
    path: '/sent',
    getParentRoute: () => AppOrgHostOutreachListRoute,
  } as any)
const AppOrgHostOutreachListSettingsRoute =
  AppOrgHostOutreachListSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppOrgHostOutreachListRoute,
  } as any)
const AppOrgHostSearchListIndexRoute =
  AppOrgHostSearchListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrgHostSearchListRoute,
  } as any)
const AppOrgHostSearchListSerpRoute =
  AppOrgHostSearchListSerpRouteImport.update({
    id: '/serp',
    path: '/serp',
    getParentRoute: () => AppOrgHostSearchListRoute,
  } as any)
const AppOrgHostSearchSerpQueryIdRoute =
  AppOrgHostSearchSerpQueryIdRouteImport.update({
    id: '/search/serp/$queryId',
    path: '/search/serp/$queryId',
    getParentRoute: () => AppOrgHostRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/design': typeof DesignRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/$org': typeof AppOrgRouteWithChildren
  '/admin': typeof AppAdminRouteWithChildren
  '/connect/callback': typeof ConnectCallbackRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/$org/$host': typeof AppOrgHostRouteWithChildren
  '/$org/settings': typeof AppOrgSettingsRouteWithChildren
  '/$org/sites': typeof AppOrgSitesRoute
  '/admin/feeds': typeof AppAdminFeedsRoute
  '/admin/queues': typeof AppAdminQueuesRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/workspace': typeof AppSettingsWorkspaceRoute
  '/sites/$siteId': typeof AppSitesSiteIdRoute
  '/$org/': typeof AppOrgIndexRoute
  '/admin/': typeof AppAdminIndexRoute
  '/$org/$host/queries': typeof AppOrgHostQueriesRoute
  '/$org/$host/settings': typeof AppOrgHostSettingsRoute
  '/$org/settings/account': typeof AppOrgSettingsAccountRoute
  '/$org/settings/connections': typeof AppOrgSettingsConnectionsRoute
  '/$org/settings/workspace': typeof AppOrgSettingsWorkspaceRoute
  '/admin/actions/$actionId': typeof AppAdminActionsActionIdRoute
  '/admin/actions': typeof AppAdminActionsListRouteWithChildren
  '/admin/ai': typeof AppAdminAiListRouteWithChildren
  '/$org/$host/': typeof AppOrgHostIndexRoute
  '/$org/settings/': typeof AppOrgSettingsIndexRoute
  '/$org/$host/backlinks/$domainId': typeof AppOrgHostBacklinksDomainIdRoute
  '/$org/$host/backlinks': typeof AppOrgHostBacklinksListRouteWithChildren
  '/$org/$host/competitors': typeof AppOrgHostCompetitorsListRouteWithChildren
  '/$org/$host/keywords/$queryId': typeof AppOrgHostKeywordsQueryIdRoute
  '/$org/$host/keywords': typeof AppOrgHostKeywordsListRouteWithChildren
  '/$org/$host/outreach/$prospectId': typeof AppOrgHostOutreachProspectIdRoute
  '/$org/$host/outreach': typeof AppOrgHostOutreachListRouteWithChildren
  '/$org/$host/pages/$pageId': typeof AppOrgHostPagesPageIdRoute
  '/$org/$host/search': typeof AppOrgHostSearchListRouteWithChildren
  '/admin/actions/detectors': typeof AppAdminActionsListDetectorsRoute
  '/admin/actions/efficacy': typeof AppAdminActionsListEfficacyRoute
  '/admin/ai/models': typeof AppAdminAiListModelsRoute
  '/admin/ai/prompts': typeof AppAdminAiListPromptsRoute
  '/admin/ai/prompts/$promptId': typeof AppAdminAiPromptsPromptIdRoute
  '/admin/ai/runs/$runId': typeof AppAdminAiRunsRunIdRoute
  '/$org/$host/pages/': typeof AppOrgHostPagesIndexRoute
  '/admin/actions/': typeof AppAdminActionsListIndexRoute
  '/admin/ai/': typeof AppAdminAiListIndexRoute
  '/$org/$host/backlinks/dead': typeof AppOrgHostBacklinksListDeadRoute
  '/$org/$host/backlinks/gained': typeof AppOrgHostBacklinksListGainedRoute
  '/$org/$host/backlinks/lost': typeof AppOrgHostBacklinksListLostRoute
  '/$org/$host/competitors/$competitorId': typeof AppOrgHostCompetitorsListCompetitorIdRoute
  '/$org/$host/competitors/manage': typeof AppOrgHostCompetitorsListManageRoute
  '/$org/$host/keywords/low-hanging': typeof AppOrgHostKeywordsListLowHangingRoute
  '/$org/$host/outreach/accepted': typeof AppOrgHostOutreachListAcceptedRoute
  '/$org/$host/outreach/active': typeof AppOrgHostOutreachListActiveRoute
  '/$org/$host/outreach/approved': typeof AppOrgHostOutreachListApprovedRoute
  '/$org/$host/outreach/dismissed': typeof AppOrgHostOutreachListDismissedRoute
  '/$org/$host/outreach/no-reply': typeof AppOrgHostOutreachListNoReplyRoute
  '/$org/$host/outreach/pipeline': typeof AppOrgHostOutreachListPipelineRoute
  '/$org/$host/outreach/rejected': typeof AppOrgHostOutreachListRejectedRoute
  '/$org/$host/outreach/sent': typeof AppOrgHostOutreachListSentRoute
  '/$org/$host/outreach/settings': typeof AppOrgHostOutreachListSettingsRoute
  '/$org/$host/search/serp': typeof AppOrgHostSearchListSerpRoute
  '/$org/$host/search/serp/$queryId': typeof AppOrgHostSearchSerpQueryIdRoute
  '/$org/$host/backlinks/': typeof AppOrgHostBacklinksListIndexRoute
  '/$org/$host/competitors/': typeof AppOrgHostCompetitorsListIndexRoute
  '/$org/$host/keywords/': typeof AppOrgHostKeywordsListIndexRoute
  '/$org/$host/outreach/': typeof AppOrgHostOutreachListIndexRoute
  '/$org/$host/search/': typeof AppOrgHostSearchListIndexRoute
}
export interface FileRoutesByTo {
  '/design': typeof DesignRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/connect/callback': typeof ConnectCallbackRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/': typeof AppIndexRoute
  '/$org/sites': typeof AppOrgSitesRoute
  '/admin/feeds': typeof AppAdminFeedsRoute
  '/admin/queues': typeof AppAdminQueuesRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/workspace': typeof AppSettingsWorkspaceRoute
  '/sites/$siteId': typeof AppSitesSiteIdRoute
  '/$org': typeof AppOrgIndexRoute
  '/admin': typeof AppAdminIndexRoute
  '/$org/$host/queries': typeof AppOrgHostQueriesRoute
  '/$org/$host/settings': typeof AppOrgHostSettingsRoute
  '/$org/settings/account': typeof AppOrgSettingsAccountRoute
  '/$org/settings/connections': typeof AppOrgSettingsConnectionsRoute
  '/$org/settings/workspace': typeof AppOrgSettingsWorkspaceRoute
  '/admin/actions/$actionId': typeof AppAdminActionsActionIdRoute
  '/$org/$host': typeof AppOrgHostIndexRoute
  '/$org/settings': typeof AppOrgSettingsIndexRoute
  '/$org/$host/backlinks/$domainId': typeof AppOrgHostBacklinksDomainIdRoute
  '/$org/$host/keywords/$queryId': typeof AppOrgHostKeywordsQueryIdRoute
  '/$org/$host/outreach/$prospectId': typeof AppOrgHostOutreachProspectIdRoute
  '/$org/$host/pages/$pageId': typeof AppOrgHostPagesPageIdRoute
  '/admin/actions/detectors': typeof AppAdminActionsListDetectorsRoute
  '/admin/actions/efficacy': typeof AppAdminActionsListEfficacyRoute
  '/admin/ai/models': typeof AppAdminAiListModelsRoute
  '/admin/ai/prompts': typeof AppAdminAiListPromptsRoute
  '/admin/ai/prompts/$promptId': typeof AppAdminAiPromptsPromptIdRoute
  '/admin/ai/runs/$runId': typeof AppAdminAiRunsRunIdRoute
  '/$org/$host/pages': typeof AppOrgHostPagesIndexRoute
  '/admin/actions': typeof AppAdminActionsListIndexRoute
  '/admin/ai': typeof AppAdminAiListIndexRoute
  '/$org/$host/backlinks/dead': typeof AppOrgHostBacklinksListDeadRoute
  '/$org/$host/backlinks/gained': typeof AppOrgHostBacklinksListGainedRoute
  '/$org/$host/backlinks/lost': typeof AppOrgHostBacklinksListLostRoute
  '/$org/$host/competitors/$competitorId': typeof AppOrgHostCompetitorsListCompetitorIdRoute
  '/$org/$host/competitors/manage': typeof AppOrgHostCompetitorsListManageRoute
  '/$org/$host/keywords/low-hanging': typeof AppOrgHostKeywordsListLowHangingRoute
  '/$org/$host/outreach/accepted': typeof AppOrgHostOutreachListAcceptedRoute
  '/$org/$host/outreach/active': typeof AppOrgHostOutreachListActiveRoute
  '/$org/$host/outreach/approved': typeof AppOrgHostOutreachListApprovedRoute
  '/$org/$host/outreach/dismissed': typeof AppOrgHostOutreachListDismissedRoute
  '/$org/$host/outreach/no-reply': typeof AppOrgHostOutreachListNoReplyRoute
  '/$org/$host/outreach/pipeline': typeof AppOrgHostOutreachListPipelineRoute
  '/$org/$host/outreach/rejected': typeof AppOrgHostOutreachListRejectedRoute
  '/$org/$host/outreach/sent': typeof AppOrgHostOutreachListSentRoute
  '/$org/$host/outreach/settings': typeof AppOrgHostOutreachListSettingsRoute
  '/$org/$host/search/serp': typeof AppOrgHostSearchListSerpRoute
  '/$org/$host/search/serp/$queryId': typeof AppOrgHostSearchSerpQueryIdRoute
  '/$org/$host/backlinks': typeof AppOrgHostBacklinksListIndexRoute
  '/$org/$host/competitors': typeof AppOrgHostCompetitorsListIndexRoute
  '/$org/$host/keywords': typeof AppOrgHostKeywordsListIndexRoute
  '/$org/$host/outreach': typeof AppOrgHostOutreachListIndexRoute
  '/$org/$host/search': typeof AppOrgHostSearchListIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/design': typeof DesignRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_app/$org': typeof AppOrgRouteWithChildren
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/connect/callback': typeof ConnectCallbackRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/_app/': typeof AppIndexRoute
  '/_app/$org/$host': typeof AppOrgHostRouteWithChildren
  '/_app/$org/settings': typeof AppOrgSettingsRouteWithChildren
  '/_app/$org/sites': typeof AppOrgSitesRoute
  '/_app/admin/feeds': typeof AppAdminFeedsRoute
  '/_app/admin/queues': typeof AppAdminQueuesRoute
  '/_app/settings/account': typeof AppSettingsAccountRoute
  '/_app/settings/workspace': typeof AppSettingsWorkspaceRoute
  '/_app/sites/$siteId': typeof AppSitesSiteIdRoute
  '/_app/$org/': typeof AppOrgIndexRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/$org/$host/queries': typeof AppOrgHostQueriesRoute
  '/_app/$org/$host/settings': typeof AppOrgHostSettingsRoute
  '/_app/$org/settings/account': typeof AppOrgSettingsAccountRoute
  '/_app/$org/settings/connections': typeof AppOrgSettingsConnectionsRoute
  '/_app/$org/settings/workspace': typeof AppOrgSettingsWorkspaceRoute
  '/_app/admin/actions/$actionId': typeof AppAdminActionsActionIdRoute
  '/_app/admin/actions/_list': typeof AppAdminActionsListRouteWithChildren
  '/_app/admin/ai/_list': typeof AppAdminAiListRouteWithChildren
  '/_app/$org/$host/': typeof AppOrgHostIndexRoute
  '/_app/$org/settings/': typeof AppOrgSettingsIndexRoute
  '/_app/$org/$host/backlinks/$domainId': typeof AppOrgHostBacklinksDomainIdRoute
  '/_app/$org/$host/backlinks/_list': typeof AppOrgHostBacklinksListRouteWithChildren
  '/_app/$org/$host/competitors/_list': typeof AppOrgHostCompetitorsListRouteWithChildren
  '/_app/$org/$host/keywords/$queryId': typeof AppOrgHostKeywordsQueryIdRoute
  '/_app/$org/$host/keywords/_list': typeof AppOrgHostKeywordsListRouteWithChildren
  '/_app/$org/$host/outreach/$prospectId': typeof AppOrgHostOutreachProspectIdRoute
  '/_app/$org/$host/outreach/_list': typeof AppOrgHostOutreachListRouteWithChildren
  '/_app/$org/$host/pages/$pageId': typeof AppOrgHostPagesPageIdRoute
  '/_app/$org/$host/search/_list': typeof AppOrgHostSearchListRouteWithChildren
  '/_app/admin/actions/_list/detectors': typeof AppAdminActionsListDetectorsRoute
  '/_app/admin/actions/_list/efficacy': typeof AppAdminActionsListEfficacyRoute
  '/_app/admin/ai/_list/models': typeof AppAdminAiListModelsRoute
  '/_app/admin/ai/_list/prompts': typeof AppAdminAiListPromptsRoute
  '/_app/admin/ai/prompts/$promptId': typeof AppAdminAiPromptsPromptIdRoute
  '/_app/admin/ai/runs/$runId': typeof AppAdminAiRunsRunIdRoute
  '/_app/$org/$host/pages/': typeof AppOrgHostPagesIndexRoute
  '/_app/admin/actions/_list/': typeof AppAdminActionsListIndexRoute
  '/_app/admin/ai/_list/': typeof AppAdminAiListIndexRoute
  '/_app/$org/$host/backlinks/_list/dead': typeof AppOrgHostBacklinksListDeadRoute
  '/_app/$org/$host/backlinks/_list/gained': typeof AppOrgHostBacklinksListGainedRoute
  '/_app/$org/$host/backlinks/_list/lost': typeof AppOrgHostBacklinksListLostRoute
  '/_app/$org/$host/competitors/_list/$competitorId': typeof AppOrgHostCompetitorsListCompetitorIdRoute
  '/_app/$org/$host/competitors/_list/manage': typeof AppOrgHostCompetitorsListManageRoute
  '/_app/$org/$host/keywords/_list/low-hanging': typeof AppOrgHostKeywordsListLowHangingRoute
  '/_app/$org/$host/outreach/_list/accepted': typeof AppOrgHostOutreachListAcceptedRoute
  '/_app/$org/$host/outreach/_list/active': typeof AppOrgHostOutreachListActiveRoute
  '/_app/$org/$host/outreach/_list/approved': typeof AppOrgHostOutreachListApprovedRoute
  '/_app/$org/$host/outreach/_list/dismissed': typeof AppOrgHostOutreachListDismissedRoute
  '/_app/$org/$host/outreach/_list/no-reply': typeof AppOrgHostOutreachListNoReplyRoute
  '/_app/$org/$host/outreach/_list/pipeline': typeof AppOrgHostOutreachListPipelineRoute
  '/_app/$org/$host/outreach/_list/rejected': typeof AppOrgHostOutreachListRejectedRoute
  '/_app/$org/$host/outreach/_list/sent': typeof AppOrgHostOutreachListSentRoute
  '/_app/$org/$host/outreach/_list/settings': typeof AppOrgHostOutreachListSettingsRoute
  '/_app/$org/$host/search/_list/serp': typeof AppOrgHostSearchListSerpRoute
  '/_app/$org/$host/search/serp/$queryId': typeof AppOrgHostSearchSerpQueryIdRoute
  '/_app/$org/$host/backlinks/_list/': typeof AppOrgHostBacklinksListIndexRoute
  '/_app/$org/$host/competitors/_list/': typeof AppOrgHostCompetitorsListIndexRoute
  '/_app/$org/$host/keywords/_list/': typeof AppOrgHostKeywordsListIndexRoute
  '/_app/$org/$host/outreach/_list/': typeof AppOrgHostOutreachListIndexRoute
  '/_app/$org/$host/search/_list/': typeof AppOrgHostSearchListIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/design'
    | '/login'
    | '/signup'
    | '/$org'
    | '/admin'
    | '/connect/callback'
    | '/invite/$invitationId'
    | '/$org/$host'
    | '/$org/settings'
    | '/$org/sites'
    | '/admin/feeds'
    | '/admin/queues'
    | '/settings/account'
    | '/settings/workspace'
    | '/sites/$siteId'
    | '/$org/'
    | '/admin/'
    | '/$org/$host/queries'
    | '/$org/$host/settings'
    | '/$org/settings/account'
    | '/$org/settings/connections'
    | '/$org/settings/workspace'
    | '/admin/actions/$actionId'
    | '/admin/actions'
    | '/admin/ai'
    | '/$org/$host/'
    | '/$org/settings/'
    | '/$org/$host/backlinks/$domainId'
    | '/$org/$host/backlinks'
    | '/$org/$host/competitors'
    | '/$org/$host/keywords/$queryId'
    | '/$org/$host/keywords'
    | '/$org/$host/outreach/$prospectId'
    | '/$org/$host/outreach'
    | '/$org/$host/pages/$pageId'
    | '/$org/$host/search'
    | '/admin/actions/detectors'
    | '/admin/actions/efficacy'
    | '/admin/ai/models'
    | '/admin/ai/prompts'
    | '/admin/ai/prompts/$promptId'
    | '/admin/ai/runs/$runId'
    | '/$org/$host/pages/'
    | '/admin/actions/'
    | '/admin/ai/'
    | '/$org/$host/backlinks/dead'
    | '/$org/$host/backlinks/gained'
    | '/$org/$host/backlinks/lost'
    | '/$org/$host/competitors/$competitorId'
    | '/$org/$host/competitors/manage'
    | '/$org/$host/keywords/low-hanging'
    | '/$org/$host/outreach/accepted'
    | '/$org/$host/outreach/active'
    | '/$org/$host/outreach/approved'
    | '/$org/$host/outreach/dismissed'
    | '/$org/$host/outreach/no-reply'
    | '/$org/$host/outreach/pipeline'
    | '/$org/$host/outreach/rejected'
    | '/$org/$host/outreach/sent'
    | '/$org/$host/outreach/settings'
    | '/$org/$host/search/serp'
    | '/$org/$host/search/serp/$queryId'
    | '/$org/$host/backlinks/'
    | '/$org/$host/competitors/'
    | '/$org/$host/keywords/'
    | '/$org/$host/outreach/'
    | '/$org/$host/search/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/design'
    | '/login'
    | '/signup'
    | '/connect/callback'
    | '/invite/$invitationId'
    | '/'
    | '/$org/sites'
    | '/admin/feeds'
    | '/admin/queues'
    | '/settings/account'
    | '/settings/workspace'
    | '/sites/$siteId'
    | '/$org'
    | '/admin'
    | '/$org/$host/queries'
    | '/$org/$host/settings'
    | '/$org/settings/account'
    | '/$org/settings/connections'
    | '/$org/settings/workspace'
    | '/admin/actions/$actionId'
    | '/$org/$host'
    | '/$org/settings'
    | '/$org/$host/backlinks/$domainId'
    | '/$org/$host/keywords/$queryId'
    | '/$org/$host/outreach/$prospectId'
    | '/$org/$host/pages/$pageId'
    | '/admin/actions/detectors'
    | '/admin/actions/efficacy'
    | '/admin/ai/models'
    | '/admin/ai/prompts'
    | '/admin/ai/prompts/$promptId'
    | '/admin/ai/runs/$runId'
    | '/$org/$host/pages'
    | '/admin/actions'
    | '/admin/ai'
    | '/$org/$host/backlinks/dead'
    | '/$org/$host/backlinks/gained'
    | '/$org/$host/backlinks/lost'
    | '/$org/$host/competitors/$competitorId'
    | '/$org/$host/competitors/manage'
    | '/$org/$host/keywords/low-hanging'
    | '/$org/$host/outreach/accepted'
    | '/$org/$host/outreach/active'
    | '/$org/$host/outreach/approved'
    | '/$org/$host/outreach/dismissed'
    | '/$org/$host/outreach/no-reply'
    | '/$org/$host/outreach/pipeline'
    | '/$org/$host/outreach/rejected'
    | '/$org/$host/outreach/sent'
    | '/$org/$host/outreach/settings'
    | '/$org/$host/search/serp'
    | '/$org/$host/search/serp/$queryId'
    | '/$org/$host/backlinks'
    | '/$org/$host/competitors'
    | '/$org/$host/keywords'
    | '/$org/$host/outreach'
    | '/$org/$host/search'
  id:
    | '__root__'
    | '/_app'
    | '/design'
    | '/login'
    | '/signup'
    | '/_app/$org'
    | '/_app/admin'
    | '/connect/callback'
    | '/invite/$invitationId'
    | '/_app/'
    | '/_app/$org/$host'
    | '/_app/$org/settings'
    | '/_app/$org/sites'
    | '/_app/admin/feeds'
    | '/_app/admin/queues'
    | '/_app/settings/account'
    | '/_app/settings/workspace'
    | '/_app/sites/$siteId'
    | '/_app/$org/'
    | '/_app/admin/'
    | '/_app/$org/$host/queries'
    | '/_app/$org/$host/settings'
    | '/_app/$org/settings/account'
    | '/_app/$org/settings/connections'
    | '/_app/$org/settings/workspace'
    | '/_app/admin/actions/$actionId'
    | '/_app/admin/actions/_list'
    | '/_app/admin/ai/_list'
    | '/_app/$org/$host/'
    | '/_app/$org/settings/'
    | '/_app/$org/$host/backlinks/$domainId'
    | '/_app/$org/$host/backlinks/_list'
    | '/_app/$org/$host/competitors/_list'
    | '/_app/$org/$host/keywords/$queryId'
    | '/_app/$org/$host/keywords/_list'
    | '/_app/$org/$host/outreach/$prospectId'
    | '/_app/$org/$host/outreach/_list'
    | '/_app/$org/$host/pages/$pageId'
    | '/_app/$org/$host/search/_list'
    | '/_app/admin/actions/_list/detectors'
    | '/_app/admin/actions/_list/efficacy'
    | '/_app/admin/ai/_list/models'
    | '/_app/admin/ai/_list/prompts'
    | '/_app/admin/ai/prompts/$promptId'
    | '/_app/admin/ai/runs/$runId'
    | '/_app/$org/$host/pages/'
    | '/_app/admin/actions/_list/'
    | '/_app/admin/ai/_list/'
    | '/_app/$org/$host/backlinks/_list/dead'
    | '/_app/$org/$host/backlinks/_list/gained'
    | '/_app/$org/$host/backlinks/_list/lost'
    | '/_app/$org/$host/competitors/_list/$competitorId'
    | '/_app/$org/$host/competitors/_list/manage'
    | '/_app/$org/$host/keywords/_list/low-hanging'
    | '/_app/$org/$host/outreach/_list/accepted'
    | '/_app/$org/$host/outreach/_list/active'
    | '/_app/$org/$host/outreach/_list/approved'
    | '/_app/$org/$host/outreach/_list/dismissed'
    | '/_app/$org/$host/outreach/_list/no-reply'
    | '/_app/$org/$host/outreach/_list/pipeline'
    | '/_app/$org/$host/outreach/_list/rejected'
    | '/_app/$org/$host/outreach/_list/sent'
    | '/_app/$org/$host/outreach/_list/settings'
    | '/_app/$org/$host/search/_list/serp'
    | '/_app/$org/$host/search/serp/$queryId'
    | '/_app/$org/$host/backlinks/_list/'
    | '/_app/$org/$host/competitors/_list/'
    | '/_app/$org/$host/keywords/_list/'
    | '/_app/$org/$host/outreach/_list/'
    | '/_app/$org/$host/search/_list/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  DesignRoute: typeof DesignRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  ConnectCallbackRoute: typeof ConnectCallbackRoute
  InviteInvitationIdRoute: typeof InviteInvitationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design': {
      id: '/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof DesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$org': {
      id: '/_app/$org'
      path: '/$org'
      fullPath: '/$org'
      preLoaderRoute: typeof AppOrgRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/connect/callback': {
      id: '/connect/callback'
      path: '/connect/callback'
      fullPath: '/connect/callback'
      preLoaderRoute: typeof ConnectCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$invitationId': {
      id: '/invite/$invitationId'
      path: '/invite/$invitationId'
      fullPath: '/invite/$invitationId'
      preLoaderRoute: typeof InviteInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/$org/': {
      id: '/_app/$org/'
      path: '/'
      fullPath: '/$org/'
      preLoaderRoute: typeof AppOrgIndexRouteImport
      parentRoute: typeof AppOrgRoute
    }
    '/_app/$org/$host': {
      id: '/_app/$org/$host'
      path: '/$host'
      fullPath: '/$org/$host'
      preLoaderRoute: typeof AppOrgHostRouteImport
      parentRoute: typeof AppOrgRoute
    }
    '/_app/$org/settings': {
      id: '/_app/$org/settings'
      path: '/settings'
      fullPath: '/$org/settings'
      preLoaderRoute: typeof AppOrgSettingsRouteImport
      parentRoute: typeof AppOrgRoute
    }
    '/_app/$org/sites': {
      id: '/_app/$org/sites'
      path: '/sites'
      fullPath: '/$org/sites'
      preLoaderRoute: typeof AppOrgSitesRouteImport
      parentRoute: typeof AppOrgRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/feeds': {
      id: '/_app/admin/feeds'
      path: '/feeds'
      fullPath: '/admin/feeds'
      preLoaderRoute: typeof AppAdminFeedsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/queues': {
      id: '/_app/admin/queues'
      path: '/queues'
      fullPath: '/admin/queues'
      preLoaderRoute: typeof AppAdminQueuesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/settings/account': {
      id: '/_app/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AppSettingsAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/workspace': {
      id: '/_app/settings/workspace'
      path: '/settings/workspace'
      fullPath: '/settings/workspace'
      preLoaderRoute: typeof AppSettingsWorkspaceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sites/$siteId': {
      id: '/_app/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/sites/$siteId'
      preLoaderRoute: typeof AppSitesSiteIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$org/$host/': {
      id: '/_app/$org/$host/'
      path: '/'
      fullPath: '/$org/$host/'
      preLoaderRoute: typeof AppOrgHostIndexRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/$org/$host/queries': {
      id: '/_app/$org/$host/queries'
      path: '/queries'
      fullPath: '/$org/$host/queries'
      preLoaderRoute: typeof AppOrgHostQueriesRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/$org/$host/settings': {
      id: '/_app/$org/$host/settings'
      path: '/settings'
      fullPath: '/$org/$host/settings'
      preLoaderRoute: typeof AppOrgHostSettingsRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/$org/settings/': {
      id: '/_app/$org/settings/'
      path: '/'
      fullPath: '/$org/settings/'
      preLoaderRoute: typeof AppOrgSettingsIndexRouteImport
      parentRoute: typeof AppOrgSettingsRoute
    }
    '/_app/$org/settings/account': {
      id: '/_app/$org/settings/account'
      path: '/account'
      fullPath: '/$org/settings/account'
      preLoaderRoute: typeof AppOrgSettingsAccountRouteImport
      parentRoute: typeof AppOrgSettingsRoute
    }
    '/_app/$org/settings/connections': {
      id: '/_app/$org/settings/connections'
      path: '/connections'
      fullPath: '/$org/settings/connections'
      preLoaderRoute: typeof AppOrgSettingsConnectionsRouteImport
      parentRoute: typeof AppOrgSettingsRoute
    }
    '/_app/$org/settings/workspace': {
      id: '/_app/$org/settings/workspace'
      path: '/workspace'
      fullPath: '/$org/settings/workspace'
      preLoaderRoute: typeof AppOrgSettingsWorkspaceRouteImport
      parentRoute: typeof AppOrgSettingsRoute
    }
    '/_app/admin/actions/$actionId': {
      id: '/_app/admin/actions/$actionId'
      path: '/actions/$actionId'
      fullPath: '/admin/actions/$actionId'
      preLoaderRoute: typeof AppAdminActionsActionIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/actions/_list': {
      id: '/_app/admin/actions/_list'
      path: '/actions'
      fullPath: '/admin/actions'
      preLoaderRoute: typeof AppAdminActionsListRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/ai/_list': {
      id: '/_app/admin/ai/_list'
      path: '/ai'
      fullPath: '/admin/ai'
      preLoaderRoute: typeof AppAdminAiListRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/$org/$host/backlinks/$domainId': {
      id: '/_app/$org/$host/backlinks/$domainId'
      path: '/backlinks/$domainId'
      fullPath: '/$org/$host/backlinks/$domainId'
      preLoaderRoute: typeof AppOrgHostBacklinksDomainIdRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/$org/$host/backlinks/_list': {
      id: '/_app/$org/$host/backlinks/_list'
      path: '/backlinks'
      fullPath: '/$org/$host/backlinks'
      preLoaderRoute: typeof AppOrgHostBacklinksListRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/$org/$host/competitors/_list': {
      id: '/_app/$org/$host/competitors/_list'
      path: '/competitors'
      fullPath: '/$org/$host/competitors'
      preLoaderRoute: typeof AppOrgHostCompetitorsListRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/$org/$host/keywords/$queryId': {
      id: '/_app/$org/$host/keywords/$queryId'
      path: '/keywords/$queryId'
      fullPath: '/$org/$host/keywords/$queryId'
      preLoaderRoute: typeof AppOrgHostKeywordsQueryIdRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/$org/$host/keywords/_list': {
      id: '/_app/$org/$host/keywords/_list'
      path: '/keywords'
      fullPath: '/$org/$host/keywords'
      preLoaderRoute: typeof AppOrgHostKeywordsListRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/$org/$host/outreach/$prospectId': {
      id: '/_app/$org/$host/outreach/$prospectId'
      path: '/outreach/$prospectId'
      fullPath: '/$org/$host/outreach/$prospectId'
      preLoaderRoute: typeof AppOrgHostOutreachProspectIdRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/$org/$host/outreach/_list': {
      id: '/_app/$org/$host/outreach/_list'
      path: '/outreach'
      fullPath: '/$org/$host/outreach'
      preLoaderRoute: typeof AppOrgHostOutreachListRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/$org/$host/pages/': {
      id: '/_app/$org/$host/pages/'
      path: '/pages'
      fullPath: '/$org/$host/pages/'
      preLoaderRoute: typeof AppOrgHostPagesIndexRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/$org/$host/pages/$pageId': {
      id: '/_app/$org/$host/pages/$pageId'
      path: '/pages/$pageId'
      fullPath: '/$org/$host/pages/$pageId'
      preLoaderRoute: typeof AppOrgHostPagesPageIdRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/$org/$host/search/_list': {
      id: '/_app/$org/$host/search/_list'
      path: '/search'
      fullPath: '/$org/$host/search'
      preLoaderRoute: typeof AppOrgHostSearchListRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
    '/_app/admin/actions/_list/': {
      id: '/_app/admin/actions/_list/'
      path: '/'
      fullPath: '/admin/actions/'
      preLoaderRoute: typeof AppAdminActionsListIndexRouteImport
      parentRoute: typeof AppAdminActionsListRoute
    }
    '/_app/admin/actions/_list/detectors': {
      id: '/_app/admin/actions/_list/detectors'
      path: '/detectors'
      fullPath: '/admin/actions/detectors'
      preLoaderRoute: typeof AppAdminActionsListDetectorsRouteImport
      parentRoute: typeof AppAdminActionsListRoute
    }
    '/_app/admin/actions/_list/efficacy': {
      id: '/_app/admin/actions/_list/efficacy'
      path: '/efficacy'
      fullPath: '/admin/actions/efficacy'
      preLoaderRoute: typeof AppAdminActionsListEfficacyRouteImport
      parentRoute: typeof AppAdminActionsListRoute
    }
    '/_app/admin/ai/_list/': {
      id: '/_app/admin/ai/_list/'
      path: '/'
      fullPath: '/admin/ai/'
      preLoaderRoute: typeof AppAdminAiListIndexRouteImport
      parentRoute: typeof AppAdminAiListRoute
    }
    '/_app/admin/ai/_list/models': {
      id: '/_app/admin/ai/_list/models'
      path: '/models'
      fullPath: '/admin/ai/models'
      preLoaderRoute: typeof AppAdminAiListModelsRouteImport
      parentRoute: typeof AppAdminAiListRoute
    }
    '/_app/admin/ai/_list/prompts': {
      id: '/_app/admin/ai/_list/prompts'
      path: '/prompts'
      fullPath: '/admin/ai/prompts'
      preLoaderRoute: typeof AppAdminAiListPromptsRouteImport
      parentRoute: typeof AppAdminAiListRoute
    }
    '/_app/admin/ai/prompts/$promptId': {
      id: '/_app/admin/ai/prompts/$promptId'
      path: '/ai/prompts/$promptId'
      fullPath: '/admin/ai/prompts/$promptId'
      preLoaderRoute: typeof AppAdminAiPromptsPromptIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/ai/runs/$runId': {
      id: '/_app/admin/ai/runs/$runId'
      path: '/ai/runs/$runId'
      fullPath: '/admin/ai/runs/$runId'
      preLoaderRoute: typeof AppAdminAiRunsRunIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/$org/$host/backlinks/_list/': {
      id: '/_app/$org/$host/backlinks/_list/'
      path: '/'
      fullPath: '/$org/$host/backlinks/'
      preLoaderRoute: typeof AppOrgHostBacklinksListIndexRouteImport
      parentRoute: typeof AppOrgHostBacklinksListRoute
    }
    '/_app/$org/$host/backlinks/_list/dead': {
      id: '/_app/$org/$host/backlinks/_list/dead'
      path: '/dead'
      fullPath: '/$org/$host/backlinks/dead'
      preLoaderRoute: typeof AppOrgHostBacklinksListDeadRouteImport
      parentRoute: typeof AppOrgHostBacklinksListRoute
    }
    '/_app/$org/$host/backlinks/_list/gained': {
      id: '/_app/$org/$host/backlinks/_list/gained'
      path: '/gained'
      fullPath: '/$org/$host/backlinks/gained'
      preLoaderRoute: typeof AppOrgHostBacklinksListGainedRouteImport
      parentRoute: typeof AppOrgHostBacklinksListRoute
    }
    '/_app/$org/$host/backlinks/_list/lost': {
      id: '/_app/$org/$host/backlinks/_list/lost'
      path: '/lost'
      fullPath: '/$org/$host/backlinks/lost'
      preLoaderRoute: typeof AppOrgHostBacklinksListLostRouteImport
      parentRoute: typeof AppOrgHostBacklinksListRoute
    }
    '/_app/$org/$host/competitors/_list/': {
      id: '/_app/$org/$host/competitors/_list/'
      path: '/'
      fullPath: '/$org/$host/competitors/'
      preLoaderRoute: typeof AppOrgHostCompetitorsListIndexRouteImport
      parentRoute: typeof AppOrgHostCompetitorsListRoute
    }
    '/_app/$org/$host/competitors/_list/$competitorId': {
      id: '/_app/$org/$host/competitors/_list/$competitorId'
      path: '/$competitorId'
      fullPath: '/$org/$host/competitors/$competitorId'
      preLoaderRoute: typeof AppOrgHostCompetitorsListCompetitorIdRouteImport
      parentRoute: typeof AppOrgHostCompetitorsListRoute
    }
    '/_app/$org/$host/competitors/_list/manage': {
      id: '/_app/$org/$host/competitors/_list/manage'
      path: '/manage'
      fullPath: '/$org/$host/competitors/manage'
      preLoaderRoute: typeof AppOrgHostCompetitorsListManageRouteImport
      parentRoute: typeof AppOrgHostCompetitorsListRoute
    }
    '/_app/$org/$host/keywords/_list/': {
      id: '/_app/$org/$host/keywords/_list/'
      path: '/'
      fullPath: '/$org/$host/keywords/'
      preLoaderRoute: typeof AppOrgHostKeywordsListIndexRouteImport
      parentRoute: typeof AppOrgHostKeywordsListRoute
    }
    '/_app/$org/$host/keywords/_list/low-hanging': {
      id: '/_app/$org/$host/keywords/_list/low-hanging'
      path: '/low-hanging'
      fullPath: '/$org/$host/keywords/low-hanging'
      preLoaderRoute: typeof AppOrgHostKeywordsListLowHangingRouteImport
      parentRoute: typeof AppOrgHostKeywordsListRoute
    }
    '/_app/$org/$host/outreach/_list/': {
      id: '/_app/$org/$host/outreach/_list/'
      path: '/'
      fullPath: '/$org/$host/outreach/'
      preLoaderRoute: typeof AppOrgHostOutreachListIndexRouteImport
      parentRoute: typeof AppOrgHostOutreachListRoute
    }
    '/_app/$org/$host/outreach/_list/accepted': {
      id: '/_app/$org/$host/outreach/_list/accepted'
      path: '/accepted'
      fullPath: '/$org/$host/outreach/accepted'
      preLoaderRoute: typeof AppOrgHostOutreachListAcceptedRouteImport
      parentRoute: typeof AppOrgHostOutreachListRoute
    }
    '/_app/$org/$host/outreach/_list/active': {
      id: '/_app/$org/$host/outreach/_list/active'
      path: '/active'
      fullPath: '/$org/$host/outreach/active'
      preLoaderRoute: typeof AppOrgHostOutreachListActiveRouteImport
      parentRoute: typeof AppOrgHostOutreachListRoute
    }
    '/_app/$org/$host/outreach/_list/approved': {
      id: '/_app/$org/$host/outreach/_list/approved'
      path: '/approved'
      fullPath: '/$org/$host/outreach/approved'
      preLoaderRoute: typeof AppOrgHostOutreachListApprovedRouteImport
      parentRoute: typeof AppOrgHostOutreachListRoute
    }
    '/_app/$org/$host/outreach/_list/dismissed': {
      id: '/_app/$org/$host/outreach/_list/dismissed'
      path: '/dismissed'
      fullPath: '/$org/$host/outreach/dismissed'
      preLoaderRoute: typeof AppOrgHostOutreachListDismissedRouteImport
      parentRoute: typeof AppOrgHostOutreachListRoute
    }
    '/_app/$org/$host/outreach/_list/no-reply': {
      id: '/_app/$org/$host/outreach/_list/no-reply'
      path: '/no-reply'
      fullPath: '/$org/$host/outreach/no-reply'
      preLoaderRoute: typeof AppOrgHostOutreachListNoReplyRouteImport
      parentRoute: typeof AppOrgHostOutreachListRoute
    }
    '/_app/$org/$host/outreach/_list/pipeline': {
      id: '/_app/$org/$host/outreach/_list/pipeline'
      path: '/pipeline'
      fullPath: '/$org/$host/outreach/pipeline'
      preLoaderRoute: typeof AppOrgHostOutreachListPipelineRouteImport
      parentRoute: typeof AppOrgHostOutreachListRoute
    }
    '/_app/$org/$host/outreach/_list/rejected': {
      id: '/_app/$org/$host/outreach/_list/rejected'
      path: '/rejected'
      fullPath: '/$org/$host/outreach/rejected'
      preLoaderRoute: typeof AppOrgHostOutreachListRejectedRouteImport
      parentRoute: typeof AppOrgHostOutreachListRoute
    }
    '/_app/$org/$host/outreach/_list/sent': {
      id: '/_app/$org/$host/outreach/_list/sent'
      path: '/sent'
      fullPath: '/$org/$host/outreach/sent'
      preLoaderRoute: typeof AppOrgHostOutreachListSentRouteImport
      parentRoute: typeof AppOrgHostOutreachListRoute
    }
    '/_app/$org/$host/outreach/_list/settings': {
      id: '/_app/$org/$host/outreach/_list/settings'
      path: '/settings'
      fullPath: '/$org/$host/outreach/settings'
      preLoaderRoute: typeof AppOrgHostOutreachListSettingsRouteImport
      parentRoute: typeof AppOrgHostOutreachListRoute
    }
    '/_app/$org/$host/search/_list/': {
      id: '/_app/$org/$host/search/_list/'
      path: '/'
      fullPath: '/$org/$host/search/'
      preLoaderRoute: typeof AppOrgHostSearchListIndexRouteImport
      parentRoute: typeof AppOrgHostSearchListRoute
    }
    '/_app/$org/$host/search/_list/serp': {
      id: '/_app/$org/$host/search/_list/serp'
      path: '/serp'
      fullPath: '/$org/$host/search/serp'
      preLoaderRoute: typeof AppOrgHostSearchListSerpRouteImport
      parentRoute: typeof AppOrgHostSearchListRoute
    }
    '/_app/$org/$host/search/serp/$queryId': {
      id: '/_app/$org/$host/search/serp/$queryId'
      path: '/search/serp/$queryId'
      fullPath: '/$org/$host/search/serp/$queryId'
      preLoaderRoute: typeof AppOrgHostSearchSerpQueryIdRouteImport
      parentRoute: typeof AppOrgHostRoute
    }
  }
}

interface AppOrgHostBacklinksListRouteChildren {
  AppOrgHostBacklinksListDeadRoute: typeof AppOrgHostBacklinksListDeadRoute
  AppOrgHostBacklinksListGainedRoute: typeof AppOrgHostBacklinksListGainedRoute
  AppOrgHostBacklinksListLostRoute: typeof AppOrgHostBacklinksListLostRoute
  AppOrgHostBacklinksListIndexRoute: typeof AppOrgHostBacklinksListIndexRoute
}

const AppOrgHostBacklinksListRouteChildren: AppOrgHostBacklinksListRouteChildren =
  {
    AppOrgHostBacklinksListDeadRoute: AppOrgHostBacklinksListDeadRoute,
    AppOrgHostBacklinksListGainedRoute: AppOrgHostBacklinksListGainedRoute,
    AppOrgHostBacklinksListLostRoute: AppOrgHostBacklinksListLostRoute,
    AppOrgHostBacklinksListIndexRoute: AppOrgHostBacklinksListIndexRoute,
  }

const AppOrgHostBacklinksListRouteWithChildren =
  AppOrgHostBacklinksListRoute._addFileChildren(
    AppOrgHostBacklinksListRouteChildren,
  )

interface AppOrgHostCompetitorsListRouteChildren {
  AppOrgHostCompetitorsListCompetitorIdRoute: typeof AppOrgHostCompetitorsListCompetitorIdRoute
  AppOrgHostCompetitorsListManageRoute: typeof AppOrgHostCompetitorsListManageRoute
  AppOrgHostCompetitorsListIndexRoute: typeof AppOrgHostCompetitorsListIndexRoute
}

const AppOrgHostCompetitorsListRouteChildren: AppOrgHostCompetitorsListRouteChildren =
  {
    AppOrgHostCompetitorsListCompetitorIdRoute:
      AppOrgHostCompetitorsListCompetitorIdRoute,
    AppOrgHostCompetitorsListManageRoute: AppOrgHostCompetitorsListManageRoute,
    AppOrgHostCompetitorsListIndexRoute: AppOrgHostCompetitorsListIndexRoute,
  }

const AppOrgHostCompetitorsListRouteWithChildren =
  AppOrgHostCompetitorsListRoute._addFileChildren(
    AppOrgHostCompetitorsListRouteChildren,
  )

interface AppOrgHostKeywordsListRouteChildren {
  AppOrgHostKeywordsListLowHangingRoute: typeof AppOrgHostKeywordsListLowHangingRoute
  AppOrgHostKeywordsListIndexRoute: typeof AppOrgHostKeywordsListIndexRoute
}

const AppOrgHostKeywordsListRouteChildren: AppOrgHostKeywordsListRouteChildren =
  {
    AppOrgHostKeywordsListLowHangingRoute:
      AppOrgHostKeywordsListLowHangingRoute,
    AppOrgHostKeywordsListIndexRoute: AppOrgHostKeywordsListIndexRoute,
  }

const AppOrgHostKeywordsListRouteWithChildren =
  AppOrgHostKeywordsListRoute._addFileChildren(
    AppOrgHostKeywordsListRouteChildren,
  )

interface AppOrgHostOutreachListRouteChildren {
  AppOrgHostOutreachListAcceptedRoute: typeof AppOrgHostOutreachListAcceptedRoute
  AppOrgHostOutreachListActiveRoute: typeof AppOrgHostOutreachListActiveRoute
  AppOrgHostOutreachListApprovedRoute: typeof AppOrgHostOutreachListApprovedRoute
  AppOrgHostOutreachListDismissedRoute: typeof AppOrgHostOutreachListDismissedRoute
  AppOrgHostOutreachListNoReplyRoute: typeof AppOrgHostOutreachListNoReplyRoute
  AppOrgHostOutreachListPipelineRoute: typeof AppOrgHostOutreachListPipelineRoute
  AppOrgHostOutreachListRejectedRoute: typeof AppOrgHostOutreachListRejectedRoute
  AppOrgHostOutreachListSentRoute: typeof AppOrgHostOutreachListSentRoute
  AppOrgHostOutreachListSettingsRoute: typeof AppOrgHostOutreachListSettingsRoute
  AppOrgHostOutreachListIndexRoute: typeof AppOrgHostOutreachListIndexRoute
}

const AppOrgHostOutreachListRouteChildren: AppOrgHostOutreachListRouteChildren =
  {
    AppOrgHostOutreachListAcceptedRoute: AppOrgHostOutreachListAcceptedRoute,
    AppOrgHostOutreachListActiveRoute: AppOrgHostOutreachListActiveRoute,
    AppOrgHostOutreachListApprovedRoute: AppOrgHostOutreachListApprovedRoute,
    AppOrgHostOutreachListDismissedRoute: AppOrgHostOutreachListDismissedRoute,
    AppOrgHostOutreachListNoReplyRoute: AppOrgHostOutreachListNoReplyRoute,
    AppOrgHostOutreachListPipelineRoute: AppOrgHostOutreachListPipelineRoute,
    AppOrgHostOutreachListRejectedRoute: AppOrgHostOutreachListRejectedRoute,
    AppOrgHostOutreachListSentRoute: AppOrgHostOutreachListSentRoute,
    AppOrgHostOutreachListSettingsRoute: AppOrgHostOutreachListSettingsRoute,
    AppOrgHostOutreachListIndexRoute: AppOrgHostOutreachListIndexRoute,
  }

const AppOrgHostOutreachListRouteWithChildren =
  AppOrgHostOutreachListRoute._addFileChildren(
    AppOrgHostOutreachListRouteChildren,
  )

interface AppOrgHostSearchListRouteChildren {
  AppOrgHostSearchListSerpRoute: typeof AppOrgHostSearchListSerpRoute
  AppOrgHostSearchListIndexRoute: typeof AppOrgHostSearchListIndexRoute
}

const AppOrgHostSearchListRouteChildren: AppOrgHostSearchListRouteChildren = {
  AppOrgHostSearchListSerpRoute: AppOrgHostSearchListSerpRoute,
  AppOrgHostSearchListIndexRoute: AppOrgHostSearchListIndexRoute,
}

const AppOrgHostSearchListRouteWithChildren =
  AppOrgHostSearchListRoute._addFileChildren(AppOrgHostSearchListRouteChildren)

interface AppOrgHostRouteChildren {
  AppOrgHostQueriesRoute: typeof AppOrgHostQueriesRoute
  AppOrgHostSettingsRoute: typeof AppOrgHostSettingsRoute
  AppOrgHostIndexRoute: typeof AppOrgHostIndexRoute
  AppOrgHostBacklinksDomainIdRoute: typeof AppOrgHostBacklinksDomainIdRoute
  AppOrgHostBacklinksListRoute: typeof AppOrgHostBacklinksListRouteWithChildren
  AppOrgHostCompetitorsListRoute: typeof AppOrgHostCompetitorsListRouteWithChildren
  AppOrgHostKeywordsQueryIdRoute: typeof AppOrgHostKeywordsQueryIdRoute
  AppOrgHostKeywordsListRoute: typeof AppOrgHostKeywordsListRouteWithChildren
  AppOrgHostOutreachProspectIdRoute: typeof AppOrgHostOutreachProspectIdRoute
  AppOrgHostOutreachListRoute: typeof AppOrgHostOutreachListRouteWithChildren
  AppOrgHostPagesPageIdRoute: typeof AppOrgHostPagesPageIdRoute
  AppOrgHostSearchListRoute: typeof AppOrgHostSearchListRouteWithChildren
  AppOrgHostPagesIndexRoute: typeof AppOrgHostPagesIndexRoute
  AppOrgHostSearchSerpQueryIdRoute: typeof AppOrgHostSearchSerpQueryIdRoute
}

const AppOrgHostRouteChildren: AppOrgHostRouteChildren = {
  AppOrgHostQueriesRoute: AppOrgHostQueriesRoute,
  AppOrgHostSettingsRoute: AppOrgHostSettingsRoute,
  AppOrgHostIndexRoute: AppOrgHostIndexRoute,
  AppOrgHostBacklinksDomainIdRoute: AppOrgHostBacklinksDomainIdRoute,
  AppOrgHostBacklinksListRoute: AppOrgHostBacklinksListRouteWithChildren,
  AppOrgHostCompetitorsListRoute: AppOrgHostCompetitorsListRouteWithChildren,
  AppOrgHostKeywordsQueryIdRoute: AppOrgHostKeywordsQueryIdRoute,
  AppOrgHostKeywordsListRoute: AppOrgHostKeywordsListRouteWithChildren,
  AppOrgHostOutreachProspectIdRoute: AppOrgHostOutreachProspectIdRoute,
  AppOrgHostOutreachListRoute: AppOrgHostOutreachListRouteWithChildren,
  AppOrgHostPagesPageIdRoute: AppOrgHostPagesPageIdRoute,
  AppOrgHostSearchListRoute: AppOrgHostSearchListRouteWithChildren,
  AppOrgHostPagesIndexRoute: AppOrgHostPagesIndexRoute,
  AppOrgHostSearchSerpQueryIdRoute: AppOrgHostSearchSerpQueryIdRoute,
}

const AppOrgHostRouteWithChildren = AppOrgHostRoute._addFileChildren(
  AppOrgHostRouteChildren,
)

interface AppOrgSettingsRouteChildren {
  AppOrgSettingsAccountRoute: typeof AppOrgSettingsAccountRoute
  AppOrgSettingsConnectionsRoute: typeof AppOrgSettingsConnectionsRoute
  AppOrgSettingsWorkspaceRoute: typeof AppOrgSettingsWorkspaceRoute
  AppOrgSettingsIndexRoute: typeof AppOrgSettingsIndexRoute
}

const AppOrgSettingsRouteChildren: AppOrgSettingsRouteChildren = {
  AppOrgSettingsAccountRoute: AppOrgSettingsAccountRoute,
  AppOrgSettingsConnectionsRoute: AppOrgSettingsConnectionsRoute,
  AppOrgSettingsWorkspaceRoute: AppOrgSettingsWorkspaceRoute,
  AppOrgSettingsIndexRoute: AppOrgSettingsIndexRoute,
}

const AppOrgSettingsRouteWithChildren = AppOrgSettingsRoute._addFileChildren(
  AppOrgSettingsRouteChildren,
)

interface AppOrgRouteChildren {
  AppOrgHostRoute: typeof AppOrgHostRouteWithChildren
  AppOrgSettingsRoute: typeof AppOrgSettingsRouteWithChildren
  AppOrgSitesRoute: typeof AppOrgSitesRoute
  AppOrgIndexRoute: typeof AppOrgIndexRoute
}

const AppOrgRouteChildren: AppOrgRouteChildren = {
  AppOrgHostRoute: AppOrgHostRouteWithChildren,
  AppOrgSettingsRoute: AppOrgSettingsRouteWithChildren,
  AppOrgSitesRoute: AppOrgSitesRoute,
  AppOrgIndexRoute: AppOrgIndexRoute,
}

const AppOrgRouteWithChildren =
  AppOrgRoute._addFileChildren(AppOrgRouteChildren)

interface AppAdminActionsListRouteChildren {
  AppAdminActionsListDetectorsRoute: typeof AppAdminActionsListDetectorsRoute
  AppAdminActionsListEfficacyRoute: typeof AppAdminActionsListEfficacyRoute
  AppAdminActionsListIndexRoute: typeof AppAdminActionsListIndexRoute
}

const AppAdminActionsListRouteChildren: AppAdminActionsListRouteChildren = {
  AppAdminActionsListDetectorsRoute: AppAdminActionsListDetectorsRoute,
  AppAdminActionsListEfficacyRoute: AppAdminActionsListEfficacyRoute,
  AppAdminActionsListIndexRoute: AppAdminActionsListIndexRoute,
}

const AppAdminActionsListRouteWithChildren =
  AppAdminActionsListRoute._addFileChildren(AppAdminActionsListRouteChildren)

interface AppAdminAiListRouteChildren {
  AppAdminAiListModelsRoute: typeof AppAdminAiListModelsRoute
  AppAdminAiListPromptsRoute: typeof AppAdminAiListPromptsRoute
  AppAdminAiListIndexRoute: typeof AppAdminAiListIndexRoute
}

const AppAdminAiListRouteChildren: AppAdminAiListRouteChildren = {
  AppAdminAiListModelsRoute: AppAdminAiListModelsRoute,
  AppAdminAiListPromptsRoute: AppAdminAiListPromptsRoute,
  AppAdminAiListIndexRoute: AppAdminAiListIndexRoute,
}

const AppAdminAiListRouteWithChildren = AppAdminAiListRoute._addFileChildren(
  AppAdminAiListRouteChildren,
)

interface AppAdminRouteChildren {
  AppAdminFeedsRoute: typeof AppAdminFeedsRoute
  AppAdminQueuesRoute: typeof AppAdminQueuesRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminActionsActionIdRoute: typeof AppAdminActionsActionIdRoute
  AppAdminActionsListRoute: typeof AppAdminActionsListRouteWithChildren
  AppAdminAiListRoute: typeof AppAdminAiListRouteWithChildren
  AppAdminAiPromptsPromptIdRoute: typeof AppAdminAiPromptsPromptIdRoute
  AppAdminAiRunsRunIdRoute: typeof AppAdminAiRunsRunIdRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminFeedsRoute: AppAdminFeedsRoute,
  AppAdminQueuesRoute: AppAdminQueuesRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminActionsActionIdRoute: AppAdminActionsActionIdRoute,
  AppAdminActionsListRoute: AppAdminActionsListRouteWithChildren,
  AppAdminAiListRoute: AppAdminAiListRouteWithChildren,
  AppAdminAiPromptsPromptIdRoute: AppAdminAiPromptsPromptIdRoute,
  AppAdminAiRunsRunIdRoute: AppAdminAiRunsRunIdRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppRouteChildren {
  AppOrgRoute: typeof AppOrgRouteWithChildren
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppSettingsAccountRoute: typeof AppSettingsAccountRoute
  AppSettingsWorkspaceRoute: typeof AppSettingsWorkspaceRoute
  AppSitesSiteIdRoute: typeof AppSitesSiteIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppOrgRoute: AppOrgRouteWithChildren,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppSettingsAccountRoute: AppSettingsAccountRoute,
  AppSettingsWorkspaceRoute: AppSettingsWorkspaceRoute,
  AppSitesSiteIdRoute: AppSitesSiteIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  DesignRoute: DesignRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  ConnectCallbackRoute: ConnectCallbackRoute,
  InviteInvitationIdRoute: InviteInvitationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
